import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from '../../services';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-login-split-screen',
    templateUrl: './login-split-screen.component.html',
    styleUrls: ['./login-split-screen.component.scss']
})
export class LoginSplitScreenComponent implements OnInit {
    @Input() showBackButton: boolean = false;
    @Input() backButtonLink: string = '';

    constructor(
        public settings: SettingsService,
        public sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
    }

}
